module.exports = __webpack_public_path__ + "media/images/photos/canada-592c906c5d59a5c5eeb8946caf1477af.jpg";